import { ExternalLink, Video } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

function getEmbedUrl(url: string): string | null {
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  if (/\.(mp4|webm|ogg)$/i.test(url)) return url;
  return null;
}

FieldRegistry.register({
  type: 'video',
  renderInput: ({ value, onChange }) => {
    const url = (value as string) ?? '';
    const embedUrl = url ? getEmbedUrl(url) : null;

    return (
      <div className="space-y-3">
        <input
          type="url"
          value={url}
          onChange={(e) => onChange(e.target.value || null)}
          placeholder="Podaj URL wideo (YouTube, Vimeo, lub bezpośredni link)…"
          className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm text-text-primary placeholder:text-text-tertiary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
        />
        {embedUrl && (
          <div className="overflow-hidden rounded-lg border border-border-primary">
            {/\.(mp4|webm|ogg)$/i.test(embedUrl) ? (
              /* biome-ignore lint/a11y/useMediaCaption: user-provided video */
              <video controls className="h-64 w-full">
                <source src={embedUrl} />
              </video>
            ) : (
              <iframe
                src={embedUrl}
                className="h-64 w-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Podgląd wideo"
              />
            )}
          </div>
        )}
      </div>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    return (
      <div className="flex items-center gap-2">
        <Video className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        <a
          href={String(value)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex max-w-[140px] items-center gap-1 truncate text-xs text-accent-600 hover:underline"
        >
          Video
          <ExternalLink className="h-3 w-3 flex-shrink-0" />
        </a>
      </div>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    if (!/^https?:\/\//i.test(String(value))) return 'Nieprawidłowy URL';
    return null;
  },
  defaultValue: null,
});
